// extracted by mini-css-extract-plugin
module.exports = {"notificationsStroke":"fyAVt","notificationsFill":"_1y-6t"};